enum TipoHorarioAtendimento {
    Semanal = 1,
    Sabado = 2,
    Domingo = 3,
}

export default TipoHorarioAtendimento;
